/* BEZELOR Super Deals filter bar: branded sort menu + "Up to X% off" chip. */
(function () {
  var BOLT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13.5 2 5 13.5h6L10 22l9-12h-6.2z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  function upChip(tools) {
    var chip = tools.querySelector('[data-sd-filter="big"]');
    if (!chip || chip.dataset.bzUp) return;
    var scope = tools.closest('[data-sd-section]') || document;
    var max = 0;
    scope.querySelectorAll('[data-sd-card]').forEach(function (c) {
      var v = parseInt(c.getAttribute('data-sd-pct'), 10);
      if (v > max) max = v;
    });
    if (!max) return;
    chip.dataset.bzUp = '1';
    chip.classList.add('bz-sd__chip--up');
    chip.innerHTML = BOLT + '<em>Up to</em><b>' + max + '%</b><em>off</em>';
  }

  function dropdown(sel) {
    if (sel.dataset.bzDd) return;
    sel.dataset.bzDd = '1';
    var wrap = sel.closest('.bz-sd__sort');
    if (!wrap) return;
    sel.classList.add('bz-dd__native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bz-dd__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Sort deals');

    var list = document.createElement('ul');
    list.className = 'bz-dd__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    var items = [];
    Array.prototype.forEach.call(sel.options, function (o) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = o.value;
      li.innerHTML = '<span>' + o.textContent + '</span>' + CHECK;
      list.appendChild(li);
      items.push(li);
    });

    function sync() {
      var cur = sel.options[sel.selectedIndex];
      btn.innerHTML = '<span>' + (cur ? cur.textContent : '') + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
      items.forEach(function (li) { li.setAttribute('aria-selected', String(li.dataset.value === sel.value)); });
    }
    function close() {
      list.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function open() {
      list.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var on = items.filter(function (li) { return li.getAttribute('aria-selected') === 'true'; })[0] || items[0];
      if (on) on.focus({ preventScroll: true });
    }
    function choose(li) {
      sel.value = li.dataset.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      close();
      btn.focus({ preventScroll: true });
    }
    btn.addEventListener('click', function () { if (list.hidden) open(); else close(); });
    items.forEach(function (li) { li.addEventListener('click', function () { choose(li); }); });
    list.addEventListener('keydown', function (e) {
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i + 1, items.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(i - 1, 0)].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i > -1) choose(items[i]); }
      else if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    sel.addEventListener('change', sync);
    wrap.appendChild(btn);
    wrap.appendChild(list);
    sync();
  }

  function run() {
    document.querySelectorAll('[data-sd-tools]').forEach(upChip);
    document.querySelectorAll('.bz-sd__sort select').forEach(dropdown);
  }
  /* Only observe the Super Deals section's direct parent. Its daily refresh
     replaces [data-sd-section] with a fresh section at this exact level.
     Avoid a body-wide MutationObserver reacting to unrelated storefront updates. */
  var watched = new WeakSet();
  function watchDealRefreshes() {
    if (!window.MutationObserver) return;
    document.querySelectorAll('[data-sd-section]').forEach(function (section) {
      var parent = section.parentElement;
      if (!parent || watched.has(parent)) return;
      watched.add(parent);
      new MutationObserver(function (records) {
        var hasFreshDeals = records.some(function (record) {
          return Array.prototype.some.call(record.addedNodes, function (node) {
            return node.nodeType === 1 &&
              (node.matches('[data-sd-section]') || node.querySelector('[data-sd-section]'));
          });
        });
        if (hasFreshDeals) run();
      }).observe(parent, { childList: true });
    });
  }
  function boot() {
    run();
    watchDealRefreshes();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
